import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiDeleteRisk } from '../api/risks.api';

export function useDeleteRisk(projectId: string) {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: (riskId: string) => apiDeleteRisk(projectId, riskId),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['risks', projectId] });
            qc.invalidateQueries({ queryKey: ['riskCategories', projectId] });
        },
    });
}
